import React, { useState } from 'react'
import { useEffect } from 'react'
import { getPaymentSchedule } from '../../../store/slices/groupFiles/thunks'
import { useDispatch } from 'react-redux'
import { AddPayment } from './AddPayment'
import { PaymentScheduleDetails } from './PaymentScheduleDetail'

export const PaymentSchedule = ({ groupFile }) => {
  const dispatch = useDispatch();
  const [addPayment, setAddPayment] = useState(false);

  useEffect(() => {
    dispatch(getPaymentSchedule(groupFile.id));
  }, [])

  return (
    <div style={{ marginTop: 20 }}>
      <div style={{ fontSize: 20 }}>Plan de pagos del grupo</div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button className="btn btn-light btn-icon" style={{ marginTop: 10 }}
          onClick={() => setAddPayment(true)} >Agregar Pago</button>
      </div>

      <AddPayment groupFile={groupFile} isOpen={addPayment} setIsOpen={setAddPayment} />
      <PaymentScheduleDetails groupFile={groupFile} />
    </div>
  )
}
